import Footer from "../../../components/Footer/Footer";
import NavBar from "../../../components/NavBar/NavBar";

import Title from "../../../components/Title/Title";
import CustomButton from "../../../components/Custom-Button/CustomButton";

export default function FourthCommandment() {

    return (
        <div>
            <NavBar/>
            <Title text={"Honrar Pai e Mãe"}/>

            <p className="info-text">
            Este é o primeiro mandamento da segunda tábua (dos deveres sociais) e indica a ordem da caridade na família[43]. <br/>
            Deus quer que respeitemos e amemos aqueles de quem recebemos a vida e educação (pais, avós, mestres)[43][44]. <br/>
            O Catecismo diz que ao proteger este vínculo familiar inaugurado por Deus, honramos a Deus indiretamente[43]. <br/>
            O mandamento “honrar” pai e mãe assume forma de deveres positivos: cuidar, obedecer, mostrar gratidão e afeto[43][45]. <br/>
            Ele estende-se a relações de autoridade (pátria, professores, governantes), exigindo justiça, respeito e auxílio mútuo[44].<br/> 
            A recompensa prometida (longevidade e prosperidade) mostra que o respeito pelos pais favorece a harmonia social e familiar[46].
            </p> 

            <Title text={"Aplicação Cotidiana"}/>
            <p className="info-text">
                No dia a dia, concretiza-se obedecendo aos pais em idade própria, seguindo seus conselhos com caridade e cuidado[47][45]. <br/> 
                Significa também cuidar dos pais na velhice e em dificuldades, oferecendo-lhes auxílio material e emocional[45]. <br/>
                Exigir respeito mútuo no lar (pais respeitam filhos e vice-versa) e resolver conflitos com diálogo são aplicações modernas deste mandamento. <br/>
                Em nível social, estende-se a todas as formas legítimas de autoridade: respeitar leis justas, manter ordem civil e participar da vida cívica são formas de “honrar” o espaço em que vivemos[44].
            </p> 

            <Title text={"Aspectos Teológicos"}/>

            <p className="info-text">
            A família é dom de Deus e célula da sociedade[48]. Honrar os pais reflete reconhecer Deus como Pai e provedor da vida. <br/> 
            O CIC chama a família de “igreja doméstica” onde se aprende a honrar a Deus e a viver as virtudes[48]. <br/>
            Do ponto de vista teológico, educar filhos na fé e no amor (pai e mãe vivenciando a moral cristã) é parte do mandamento[43][44]. <br/>
            O respeito aos pais, lembrando Sirácida 3,2-6, também é associado à bênção divina: a piedade filial e a justiça são caminhos para a graça[45]. <br/>
            Em suma, família e sociedade integram-se no plano divino; o mandamento socializa o amor a Deus, fazendo do respeito familiar uma extensão do amor fraterno.
            </p> 

            <CustomButton route={"/Mandamentos"} text={"Voltar"}/>
            <Footer/>
        </div>
    )
}